import { dew as _abiDew } from "../../errors/abi.js";
import { dew as _concatDew } from "../data/concat.js";
import { dew as _getFunctionSelectorDew } from "../hash/getFunctionSelector.js";
import { dew as _encodeAbiParametersDew } from "./encodeAbiParameters.js";
import { dew as _formatAbiItemDew } from "./formatAbiItem.js";
import { dew as _getAbiItemDew } from "./getAbiItem.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.encodeErrorResult = void 0;
  const abi_js_1 = _abiDew();
  const concat_js_1 = _concatDew();
  const getFunctionSelector_js_1 = _getFunctionSelectorDew();
  const encodeAbiParameters_js_1 = _encodeAbiParametersDew();
  const formatAbiItem_js_1 = _formatAbiItemDew();
  const getAbiItem_js_1 = _getAbiItemDew();
  const docsPath = "/docs/contract/encodeErrorResult";
  function encodeErrorResult({
    abi,
    errorName,
    args
  }) {
    let abiItem = abi[0];
    if (errorName) {
      abiItem = (0, getAbiItem_js_1.getAbiItem)({
        abi,
        args,
        name: errorName
      });
      if (!abiItem) throw new abi_js_1.AbiErrorNotFoundError(errorName, {
        docsPath
      });
    }
    if (abiItem.type !== "error") throw new abi_js_1.AbiErrorNotFoundError(undefined, {
      docsPath
    });
    const definition = (0, formatAbiItem_js_1.formatAbiItem)(abiItem);
    const signature = (0, getFunctionSelector_js_1.getFunctionSelector)(definition);
    let data = "0x";
    if (args && args.length > 0) {
      if (!abiItem.inputs) throw new abi_js_1.AbiErrorInputsNotFoundError(abiItem.name, {
        docsPath
      });
      data = (0, encodeAbiParameters_js_1.encodeAbiParameters)(abiItem.inputs, args);
    }
    return (0, concat_js_1.concatHex)([signature, data]);
  }
  exports.encodeErrorResult = encodeErrorResult;
  //# sourceMappingURL=encodeErrorResult.js.map
  return exports;
}